/**
 * @description: 权限路由
 * @author: linwen linwen@fjxhx.com
 * @createDate: 2020-10-22 13:53
 * @param: 权限路由
 * @return:
 */
import store from '@/store'
import {menuTopListGet} from '@/api/Menu'
import {constantRoutes, lazyLoading} from '@/router'
import {isEmptyObject} from '@/utils'
import {setRouters, removeRouters} from '@/utils/menu';


/**
 * @description: 过滤路由
 * @author: linwen linwen@fjxhx.com
 * @createDate: 2020-11-02 8:29
 * @param: routes 后端返回的路由
 * @return:
 */
export function filterRoutes(routes) {
  return routes.map((item, index) => {
    const currentRoute = {
      path: item.menuLink,
      name: item.menuLink.replace(/^\//, ''),
      component: lazyLoading(item.menuRouter),
      meta: {title: item.menuName, keepAlive: false},
      display: true
    }
    if (index === 0) currentRoute.alias = '/'
    return currentRoute
  })
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    if (routes && routes.length > 0) {
      setRouters(constantRoutes.concat(routes))
      state.addRoutes = routes
      state.routes = constantRoutes.concat(routes)
    } else {
      removeRouters()
      state.addRoutes = routes
      state.routes = routes
    }
  }
}

const actions = {
  /**
   * @description: 动态路由生成器
   * @author: linwen linwen@fjxhx.com
   * @createDate: 2020-10-22 13:55
   * @param: 动态路由生成器
   * @return:
   */
  generateRoutes({commit}) {
    return new Promise((resolve, reject) => {
      menuTopListGet({
        clientId: store.getters.clientId,
        platform: '02'
      }).then(response => {
        console.log('getMenu', response)
        if (!isEmptyObject(response)) {
          const _asyncRoutes = filterRoutes(response)
          // console.log('_asyncRoutes', _asyncRoutes)
          const accessedRoutes = [
            ..._asyncRoutes,
            {
              path: '/404',
              component: lazyLoading('@/views/404'),
            },
            { // 后置添加404页面,防止刷新404
              path: '*',
              redirect: '/404'
            }
          ]
          console.log('当前有权限路由表：', accessedRoutes)
          commit('SET_ROUTES', accessedRoutes)
          resolve(accessedRoutes)
        } else {
          reject('当前账户没有访问权限')
        }
      }).catch(error => {
        console.error('error', error)
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/permission.js